module.exports = __webpack_public_path__ + "static/media/CentroMedicoSantaRita.90e558b2.svg";